// extracted by mini-css-extract-plugin
export default {"app":"EventList_app__-cK-R","header":"EventList_header__TeSFP","content":"EventList_content__O+kDF","list":"EventList_list__HaLAM","closeBtn":"EventList_closeBtn__-ComY"};